import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bar-chart-container" }
const _hoisted_2 = { class: "alternative-title-header" }
const _hoisted_3 = {
  key: 0,
  class: "chart-wrapper"
}
const _hoisted_4 = { class: "chart-area" }
const _hoisted_5 = ["width", "height"]
const _hoisted_6 = { class: "attitude-column" }
const _hoisted_7 = {
  key: 1,
  class: "separated-charts-container"
}
const _hoisted_8 = { class: "alternative-title" }
const _hoisted_9 = { class: "chart-wrapper-separated" }
const _hoisted_10 = { class: "chart-area" }
const _hoisted_11 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.alternativeLabel), 1),
    (_ctx.selectedAlternative !== 'all-separated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("svg", {
              ref: "chartRef",
              width: _ctx.width,
              height: _ctx.height,
              class: "horizontal-bars"
            }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "attitude-header" }, "Attitude", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableRows, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.key,
                class: "attitude-item",
                style: _normalizeStyle({ backgroundColor: _ctx.getCellColor(row.attitude) })
              }, [
                _createElementVNode("div", {
                  class: "attitude-value",
                  style: _normalizeStyle({ color: row.attitude === '0.00' || (parseFloat(row.attitude) >= 0.35 && parseFloat(row.attitude) < 0.60) ? '#333' : '#fff' })
                }, _toDisplayString(row.attitude), 5)
              ], 4))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.separatedChartsData, (altData, altId) => {
            return (_openBlock(), _createElementBlock("div", {
              key: altId,
              class: "alternative-chart-card"
            }, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(altData.name), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock("svg", {
                    ref_for: true,
                    ref: (el) => _ctx.setSvgRef(String(altId), el),
                    width: _ctx.width,
                    height: altData.chartHeight,
                    class: "horizontal-bars"
                  }, null, 8, _hoisted_11))
                ]),
                _createElementVNode("div", {
                  class: "attitude-column-right",
                  style: _normalizeStyle({ height: altData.chartHeight + 'px' })
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "attitude-header" }, "Attitude", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(altData.tableRows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.key,
                      class: "attitude-item",
                      style: _normalizeStyle({ backgroundColor: _ctx.getCellColor(row.attitude) })
                    }, [
                      _createElementVNode("div", {
                        class: "attitude-value",
                        style: _normalizeStyle({ color: row.attitude === '0.00' || (parseFloat(row.attitude) >= 0.35 && parseFloat(row.attitude) < 0.60) ? '#333' : '#fff' })
                      }, _toDisplayString(row.attitude), 5)
                    ], 4))
                  }), 128))
                ], 4)
              ])
            ]))
          }), 128))
        ]))
  ]))
}